// extracted by mini-css-extract-plugin
export default {"deliveryPanel":"Style_deliveryPanel__JohP8","deliveryActions":"Style_deliveryActions__dW+2c","deliveryButton":"Style_deliveryButton__A49tp","smsButton":"Style_smsButton__pewCu"};